import React from 'react';
import { MonitorFilterStatus } from '@/services/enums';

type StatusFilter = MonitorFilterStatus;

interface FilterBarProps {
  symbolFilter: string;
  setSymbolFilter: (value: string) => void;
  statusFilter: StatusFilter;
  setStatusFilter: (value: StatusFilter) => void;
  researchLoading: boolean;
  onResearchClick: () => void;
  pipelineEnabled: boolean;
  onTogglePipeline: () => void;
  runningCount: number;
  totalMonitors: number;
}

const FilterBar: React.FC<FilterBarProps> = ({
  symbolFilter,
  setSymbolFilter,
  statusFilter,
  setStatusFilter,
  researchLoading,
  onResearchClick,
  pipelineEnabled,
  onTogglePipeline,
  runningCount,
  totalMonitors,
}) => {
  return (
    <div className="fixed left-0 right-0 z-40 border-b border-white/10 px-4 py-2" style={{ top: '56px' }}>
      <div className="flex flex-col gap-2">
        {/* 第一行：筛选输入框、状态下拉框、同步按钮 */}
        <div className="flex items-center gap-2">
          <input
            type="text"
            value={symbolFilter}
            onChange={(e) => setSymbolFilter(e.target.value)}
            placeholder="股票筛选 (代码/拼音/名称)"
            className="flex-1 bg-white/10 border border-white/20 rounded-lg px-3 py-2 text-white text-sm placeholder-white/40 focus:outline-none focus:ring-2 focus:ring-white/30 min-w-0"
          />
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value as StatusFilter)}
            className="w-24 px-2 py-2 bg-white/10 border border-white/20 rounded-lg text-white text-sm focus:outline-none focus:border-white/40 appearance-none text-center"
          >
            <option value="all" className="bg-gray-800 text-white">
              全部
            </option>
            <option value="running" className="bg-gray-800 text-white">
              运行中
            </option>
            <option value="stopped" className="bg-gray-800 text-white">
              已停止
            </option>
          </select>
          <button
            onClick={onResearchClick}
            disabled={researchLoading}
            className="flex-none px-3 py-2 rounded-lg text-sm font-medium transition-all duration-300 bg-green-500/20 border border-green-500/50 text-green-300 hover:bg-green-500/30 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
          >
            {researchLoading ? (
              <svg className="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
            ) : (
              <span>同步研报</span>
            )}
          </button>
        </div>

        {/* 第二行：运行状态 (左) 和 研报管道开关 (右) */}
        <div className="flex items-center justify-between">
          <div className="text-xs text-white/70">
            运行状态:{' '}
            <span className="text-white font-semibold">
              {runningCount} / {totalMonitors}
            </span>
          </div>

          <div className="flex items-center gap-2 px-2 py-0.5 bg-white/5 border border-white/10 rounded-lg">
            <span className="text-xs text-white/60">研报管道</span>
            <button
              onClick={onTogglePipeline}
              className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors focus:outline-none ${
                pipelineEnabled ? 'bg-green-500' : 'bg-gray-600'
              }`}
            >
              <span
                className={`inline-block h-3 w-3 transform rounded-full bg-white transition-transform ${
                  pipelineEnabled ? 'translate-x-5' : 'translate-x-1'
                }`}
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterBar;
